import React, {useEffect} from 'react';
import { Link } from "react-router-dom";
import { Box, Typography, Button, Container, useTheme, useMediaQuery  } from '@mui/material';
import Grid from '../../../common/CustomGrid'; 
import Preloader from '../../../common/Preloader'; 
import imageAlt from '../../../../assets/images/hero-image.png'; 
import AOS from 'aos';
import RawMarkup from '../../../common/RawMarkup'

const HeroSection = ({ data }) => {

    const theme = useTheme();

    useEffect(() => { AOS.init({ duration: 800, offset: 100 }); }, []);

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    if (!data) { return ( <Preloader /> ); }

    const { title = "", subtitle = "", button_link = "#", button_text= "", image = [] } = data || {};

    const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:1337";
    const imageUrl = image?.url  ? `${baseUrl}${image.url}` : imageAlt; 

    const Image = () => <Box data-aos="fade-left" component="img" src={imageUrl} alt="Hero Graphic" className='absolute-image ' />

  return (
    <Box className="hero_section-container" sx={{ py:{xs:4, md: 16}, px: { xs: 2, md: 6 }, position: 'relative', }} >
        <Container maxWidth="lg">         
            <Grid container spacing={4} alignItems="center">
                <Grid size={{ xs: 12, md: 6 }}>
                    <Typography className='title' data-aos="fade-up" variant="h1" sx={{  mb: 2, textAlign:{ xs:'center', md: 'left'}, }}>
                       <RawMarkup content={title} />
                    </Typography>
                    <Typography className='subtitle' data-aos="fade-up" variant="h6" sx={{textAlign:{ xs:'center', md: 'left'}}} >
                        {subtitle}
                    </Typography>
                    <Button data-aos="fade-up" variant="contained" component={Link} to={button_link} sx={{textAlign:{ xs:'center', md: 'left'}, }} >
                        {button_text}
                    </Button>

                    {/* <Typography className='title' data-aos="fade-up" variant="h1" sx={{  mb: 2, textAlign:{ xs:'center', md: 'left'}, }}>
                        Tu <span style={{ color: theme.palette.secondary.main, }}>Negocio,</span><br />
                        Nuestra <span style={{ color: theme.palette.secondary.main, }}>tecnología:</span>
                    </Typography> */}
                    {/* <Typography className='subtitle' data-aos="fade-up" variant="h6" sx={{textAlign:{ xs:'center', md: 'left'}}} >
                        Soluciones inteligentes para el turismo del futuro.
                    </Typography> */}
                    {/* <Button data-aos="fade-up" variant="contained" component={Link} to="/contact" sx={{textAlign:{ xs:'center', md: 'left'}, }} >
                        Solicita una Demostración
                    </Button> */}
                    
                </Grid>
            </Grid>
            {isDesktop && <Image />}
            
        </Container>
    </Box>
  );
};

export default HeroSection;

